module.exports = __webpack_public_path__ + "static/img/title_ar.7326f5ea.png";